import QRCode from 'qrcode';

document.querySelectorAll('[data-app-download-qr]').forEach(canvas => {
  const rawUrl = canvas.dataset.url?.trim();
  if (!rawUrl) return;
  const downloadUrl = new URL(rawUrl, document.baseURI).href;
  QRCode.toCanvas(canvas, downloadUrl, {
    width: 184,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#101512', light: '#ffffff' }
  }).then(() => {
    canvas.closest('.android-qr-card')?.classList.add('ready');
  }).catch(() => {
    canvas.closest('.android-qr-card')?.setAttribute('hidden', '');
  });
});
